/**
 * @generated SignedSource<<e464a71c362b174d2df1a388561467a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WSCalendarOverviewQuery$variables = {
  id: string;
};
export type WSCalendarOverviewQuery$data = {
  readonly widgetCalendarOverview: {
    readonly calendars: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly id: string;
  } | null;
};
export type WSCalendarOverviewQuery = {
  response: WSCalendarOverviewQuery$data;
  variables: WSCalendarOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "WidgetCalendarOverview",
    "kind": "LinkedField",
    "name": "widgetCalendarOverview",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "includeExternal",
            "value": true
          }
        ],
        "concreteType": "StoreCalendar",
        "kind": "LinkedField",
        "name": "calendars",
        "plural": true,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": "calendars(includeExternal:true)"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WSCalendarOverviewQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WSCalendarOverviewQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "470dcdcb89f727adfb089c86761b064e",
    "id": null,
    "metadata": {},
    "name": "WSCalendarOverviewQuery",
    "operationKind": "query",
    "text": "query WSCalendarOverviewQuery(\n  $id: ID!\n) {\n  widgetCalendarOverview(id: $id) {\n    id\n    calendars(includeExternal: true) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "77eeb2e79f66ab6721e3c305fdc5c59c";

export default node;
